export default "__VITE_ASSET__BPT6E$2M__"